import React from 'react';
import Aboutcontent from '../components/Aboutcontent';
import Footer from '../components/footer';


const Aboutpage = () => {
  return (
    <div className="About">
         
          <Aboutcontent />
          <Footer />
    </div>
  );
}

export default Aboutpage;